import {Component, input, ChangeDetectionStrategy} from "@angular/core"

/**
 * Pinned filters are shown at the top, before non-pinned filters.
 * TODO: Do we really need a separate component for this? Could we not use a normal filter in a dedicated slot?
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-pinned-filter",
    templateUrl: "./pinned-filter.component.html",
    styleUrls: ["./pinned-filter.component.scss"],
})
export class PinnedFilterComponent {
    readonly $label = input<string>("", {alias: "label"})
}
